// packages/services/src/authService.ts
import axios from "axios";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";

import { getConfig } from "@cabukaka/config";
import { AuthResponse, RegisterData, User } from "../types/User";
import { getFirebaseAuth, initFirebase } from "../firebase";

const provider = new GoogleAuthProvider();


// ❌ SUPPRIME cette ligne
// const ENV = getConfig()

export const authService = {
  async register({ email, phone, password, username, avatar, role, profileData }: RegisterData): Promise<AuthResponse> {
    const { apiUrl } = getConfig(); // ✅ Appel ici
    const { data } = await axios.post(`${apiUrl}/auth/register`, {
      email, username, avatar, phone, password, role, profileData,
    });
    return data;
  },

  async login({ email, phone, password }: { email?: string, phone?: string, password: string }): Promise<AuthResponse> {
    const { apiUrl } = getConfig(); // ✅ Appel ici
    const { data } = await axios.post(`${apiUrl}/auth/login`, {
      email, password, phone
    });
    return data;
  },

  async loginWithGoogle({role}: {role: User['role']}): Promise<AuthResponse> {
    initFirebase()
    const auth = getFirebaseAuth()
    const { apiUrl } = getConfig(); // ✅ Appel ici
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    if (!user.email) {
      throw new Error("Impossible de récupérer l'email Google.");
    }

    const { data } = await axios.post(`${apiUrl}/auth/google`, {
      email: user.email,
      username: user.displayName,
      avatar: user.photoURL,
      providerId: user.uid,
      role: role,
      profileData: {
        name: user.displayName,
        username: user.displayName,
        logoUrl: user.photoURL
      }
    });

    return data;
  },

  async getUserProfile(token: string): Promise<User> {
    const { apiUrl } = getConfig(); // ✅ Appel ici
    const { data } = await axios.get(`${apiUrl}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const user = data.user
    return {
      ...user,
      id: user._id || user.id,
    };
  },

  async logout() {
    localStorage.removeItem('token_access')
    return true;
  },

  async updateUser(
    userId: string,
    username: string,
    avatar?: string,
    newStatus?: User['status'],
  ): Promise<AuthResponse> {
    const { apiUrl } = getConfig(); // ✅ Appel ici
    const { data } = await axios.put(`${apiUrl}/auth/${userId}`, {
      username, avatar, status: newStatus,
    });
    return data;
  },

  async requestPasswordReset(email: string): Promise<{ message: string }> {
    const { apiUrl } = getConfig(); // ✅ Appel ici
    const { data } = await axios.post(`${apiUrl}/auth/request-reset-password`, { email });
    return data;
  },

  async resetPasswordWithOtp(email: string, otp: string, newPassword: string): Promise<{ message: string }> {
    const { apiUrl } = getConfig(); // ✅ Appel ici
    const { data } = await axios.post(`${apiUrl}/auth/reset-password`, { email, otp, newPassword });
    return data;
  },

  async deleleUser(userId: string, token: string) {
    const { apiUrl } = getConfig(); // ✅ Appel ici
    await axios.delete(`${apiUrl}/auth/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  getError(error: any) {
    return error?.response?.data?.message || "Une erreur s'est produite. Veuillez réessayer.";
  },
};